import type { EmergencyCommandOperation } from '@src/models/interfaces/emergency.interface';

export const EMERGENCY_COMMAND_OPERATIONS = {
  CREATE_TYPE: 'createType',
  UPDATE_TYPE: 'updateType',
  DELETE_TYPE: 'deleteType',
  SAVE_ENROLLMENT: 'saveEnrollment',
  ACTIVATE_PANIC: 'activatePanic',
  START_MONITORING: 'startMonitoring',
  END_MONITORING: 'endMonitoring',
  RECORD_MANUAL_SATISFACTION: 'recordManualSatisfaction',
  RECORD_ACTIVITY_SATISFACTION: 'recordActivitySatisfaction',
  CANCEL_FALSE_ALARM: 'cancelFalseAlarm',
  ACCEPT_PRIMARY: 'acceptPrimary',
  JOIN_SUPPORT: 'joinSupport',
  EN_ROUTE: 'enRoute',
  ARRIVED: 'arrived',
  RELEASE: 'release',
  REASSIGN: 'reassign',
  ASSIGN_PRIMARY: 'assignPrimary',
  ADD_NOTE: 'addNote',
  RESOLVE: 'resolve',
  ACKNOWLEDGE_DELIVERED: 'acknowledgeDelivered',
  ACKNOWLEDGE_VIEWED: 'acknowledgeViewed',
  PUBLISH_LOCATION: 'publishLocation',
  CREATE_INTEGRATION: 'createIntegration',
  UPDATE_INTEGRATION: 'updateIntegration',
  DELETE_INTEGRATION: 'deleteIntegration',
  ROTATE_INTEGRATION: 'rotateIntegration',
  LIST_INTEGRATIONS: 'listIntegrations',
  LIST_INTEGRATION_DELIVERIES: 'listIntegrationDeliveries',
  GET_CAPABILITIES: 'getCapabilities',
} as const satisfies Record<string, EmergencyCommandOperation>;

export interface EmergencyCommandEnvelope<TPayload extends Record<string, unknown>> {
  organizationId: string;
  divisionId?: string;
  operation: EmergencyCommandOperation;
  idempotencyKey: string;
  occurredAtDevice: Date;
  payload: TPayload;
}
